module.exports = __webpack_public_path__ + "media/packs/images/insert-cartridge-7ec5a9a81345a99008b8b6f965f3c9a6.png";